 
<template>
  <div class="min-h-screen w-[90%] mx-auto md:w-full">
      <div class="w-full sm:max-w-[880px] ">
        <!-- Header -->
        
        <!-- Description -->
        <div class="mb-4 sm:mb-2">
          <h1 class="text-xl sm:text-2xl font-semibold text-gray-900 hidden sm:block">Contact Us</h1>
          <p class="text-sm sm:text-base text-gray-600 leading-relaxed mt-3">
            You can get in touch with us through below platforms our team will reach out to you soon as it would be possible
          </p>
        </div>
   
        <!-- Contact Card -->
        <div
        class="bg-white border border-[#F0F0F0] rounded-xl p-6 flex flex-col gap-4"
        >
            <h2 class="text-sm md:text-base leading-[20px] md:leading-none font-normal text-[#626363]" >Customer Support</h2>
          <div class="flex flex-col gap-3 h-[138px] md:h-[196px] md:gap-8">
            <div class="flex items-start gap-4 h-[38px] md:h-[44px]">
              <div class="w-9 h-9 md:w-11 md:h-11 border border-[#F0F0F0] gap-2.5 rounded-lg flex items-center justify-center shrink-0">
                <img src="/v2/icons/contact-call.svg" class="w-4 h-4 " />
              </div>
              <div class="flex flex-col gap-y-1">
                <p class="text-xs md:text-sm leading-none md:leading-[20px] font-normal text-[#828282]">Contact Number</p>
                <a
                  :href="`tel:${phone}`"  
                  class="text-sm md:text-base leading-[20px] md:leading-none font-medium break-all underline text-[#111111]"
                >
                  {{ phone }}
                </a>
              </div>
            </div>
   
            <!-- Email -->
            <div class="flex items-start gap-4 h-[38px] md:h-[44px]">
              <div class="w-9 h-9 md:w-11 md:h-11 border border-[#F0F0F0] gap-2.5 rounded-lg  flex items-center justify-center shrink-0">
                <img src="/v2/icons/sms.svg" class="w-4 h-4 " />
              </div>
              <div class="flex flex-col gap-y-1">
                <p class="text-xs md:text-sm leading-none md:leading-[20px] font-normal text-[#828282]">Email ID</p>
                <a
                  :href="`mailto:${email}`"
                  class="text-sm md:text-base leading-[20px] md:leading-none font-medium underline text-[#111111]">
                  {{ email }}
                </a>
              </div>
            </div>
            
            <!-- WhatsApp -->
            <div class="flex items-start gap-4 h-[38px] md:h-[44px]">
              <div class="w-9 h-9 md:w-11 md:h-11 border border-[#F0F0F0] gap-2.5 rounded-lg  flex items-center justify-center shrink-0">
                <img src="/v2/icons/contact-whatsapp.svg" class="w-4 h-4 " />
              </div>
              <div class="flex flex-col gap-y-1">
                <p class="text-xs md:text-sm leading-none md:leading-[20px] font-normal text-[#828282]">WhatsApp</p>
                <a
                  :href="`https://wa.me/${whatsapp}`"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-sm md:text-base leading-[20px] md:leading-none font-medium underline text-[#111111]"
                >
                  {{ phone }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
   
  <script setup lang="ts">
  const { isMobile } = useDevice()
  const runtimeConfig = useRuntimeConfig();
  const phone = runtimeConfig.public.support.phone
  const whatsapp = runtimeConfig.public.support.whatsapp
  const email = runtimeConfig.public.support.email
  const navToHome = () => {
  navigateTo({path:'/'})
}
  </script>
   
   
   
   
 